import styled from "styled-components";
import Chip from "@mui/material/Chip";
import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
const BaseChip = styled(Chip).attrs({ variant: "outlined", size: "medium" }) `
    background: ${colors.white_main};
    font-weight: ${fontWeights.SEMI_BOLD};
`;
export const RedwoodChip = styled(BaseChip) `
    color: ${colors.chips_redwood};
    border-color: ${colors.chips_redwood};
`;
export const NeptuneChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_neptune};
    border-color: ${colors.chips_neptune};
`;
export const EmberChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_ember};
    border-color: ${colors.chips_ember};
`;
export const AzureChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_azure};
    border-color: ${colors.chips_azure};
`;
export const SaffronChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_saffron};
    border-color: ${colors.chips_saffron};
`;
export const AmethystChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_amethyst};
    border-color: ${colors.chips_amethyst};
`;
export const ForestChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_forest};
    border-color: ${colors.chips_forest};
`;
export const TulipChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_tulip};
    border-color: ${colors.chips_tulip};
`;
export const SlateChip = styled(BaseChip).attrs({}) `
    color: ${colors.chips_slate};
    border-color: ${colors.chips_slate};
`;
